import dayjs from "dayjs";
import { useContext, useRef } from "react";
import styled, { css } from "styled-components";
import tw from "twin.macro";
import { getUserDetailsStore, pages, useUserDetailsStore } from "../..";
import { apiRoutes, BASE_URL } from "../../../../api";
import { useMediaHover } from "../../../../App";
import styles from "../../../../common/styles";
import { DP } from "../../../../common/types";
import EditButtonC from "../../../../components/EditButtonC";
import createCustomContext from "../../../../context/customContext";
import { ProfileContext } from "../../../../context/profileContext";
import { IPost } from "../../../../sections/Post/types";
import Author from "./components/Author";
import EditButton from "./components/EditButton";

interface Props extends DP {
  post: IPost;
}

interface IContext {
  post?: IPost;
}

export const [usePostValue, usePost, withContext] =
  createCustomContext<IContext>({});

const Post = (props: Props) => {
  usePost({ post: props.post });
  const post = usePostValue((s) => s.post);
	const profile = useContext(ProfileContext)
	const params = pages[getUserDetailsStore().currentPage].postParams

  const mediaHover = useMediaHover();
  const videoRef = useRef<HTMLVideoElement | null>(null);

  const handlePointerOver = () => {
    if (mediaHover && videoRef) videoRef.current.play();
  };
  const handlePointerLeave = () => {
    if (mediaHover && videoRef) videoRef.current.pause();
  };

  return (
    <Wrapper
      onPointerOver={handlePointerOver}
      onPointerLeave={handlePointerLeave}
    >
      <Video
        ref={videoRef}
        muted={!mediaHover}
        loop
				autoPlay={!mediaHover}
				poster={post.thumbnail}
        src={post.videoId}
      />
      <Title>{post.title}</Title>
      <Topics>
        {post.topics.map((el) => (
          <p>{el.title}</p>
        ))}
      </Topics>
			{/* {params.includes('withEdit') && post.createdBy._id == profile?.user._id && <EditButton />} */}
			{params.includes('withAuthor') && <Author />}
      <CreatedAt>{dayjs(post.createdAt).format("DD MMMM")}</CreatedAt>
    </Wrapper>
  );
};

const Wrapper = styled.div(() => [
  tw`flex text-white flex-col text-[0.3rem] overflow-hidden relative items-start`,
  styles.border,
  css`
    --p: 0.7rem;
    padding: var(--p);
    aspect-ratio: 7/12;
  `,
]);

const Video = styled.video(
  () => [tw`absolute h-full object-cover w-full z-[-1]`],
  css`
    margin-left: calc(var(--p) * -1);
    margin-top: calc(var(--p) * -1);
  `
);

const Title = styled.div(() => [tw`p-0.5 break-all w-full rounded-3xl text-[0.6rem] font-bold`, css`
	backdrop-filter: blur(0.02rem) saturate(10%) opacity(20%);
`]);
const Description = styled.div(() => [tw``]);
const Topics = styled.div(() => [
  tw`flex space-x-0.5`,
  css`
    & > p::before {
      content: "#";
    }
  `,
]);

const CreatedAt = styled.div(() => [tw`absolute right-0 bottom-0 mr-2 mb-1`]);

export default styled(withContext(Post))``;
